import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  width: 150%;

  .recharts-surface {
    width: 32.857rem;
    margin-left: 16px;
  }
`;

export const InformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2.8rem;

  h1 {
    color: rgb(108, 108, 108);
  }
`;
